import { render } from "./whitePaper.vue?vue&type=template&id=87487f56&scoped=true"
import script from "./whitePaper.vue?vue&type=script&lang=js"
export * from "./whitePaper.vue?vue&type=script&lang=js"

import "./whitePaper.vue?vue&type=style&index=0&id=87487f56&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87487f56"]])

export default __exports__